<template>
  <q-list class="no-focus" v-if="!not_allowed_plans.includes(plan_brand(selected_plan))">

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_1" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I have verified my enrollment details on this page and confirm everything is correct.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_2" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I understand that a move-in or switch request can only be made by the electric service applicant or the
          applicants authorized agent. I confirm that I am at least eighteen years of age and legally authorized to
          change REPs for this address. I understand that I am authorizing {{ plan_brand(selected_plan) }} to become my
          new Retail Electric Provider (REP) in place of my current REP, if applicable. I authorize
          {{ plan_brand(selected_plan) }} to perform the necessary tasks in order to make this change.
        </q-item-label>
      </q-item-section>
    </q-item>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_3" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I have read and understand the contract documents for this plan, which include the Terms of Service,
          Electricity Facts Label and Your Rights as a Customer documents. I understand that after submitting this
          enrollment request, I will also receive a copy of these documents, including the Terms of Service, from
          {{ plan_brand(selected_plan) }} via email, and upon request with {{ plan_brand(selected_plan) }}, via US mail,
          and that these documents, including the Terms of Service, explain all the terms of the agreement and how to
          exercise the right of rescission, if applicable.
        </q-item-label>
      </q-item-section>
    </q-item>

  </q-list>
</template>

<script>
import SelectedPlan from "src/composables/SelectedPlan";
import { watch, ref } from "vue";
import Utilities from "src/composables/Utilities";

export default {
  name: "StandardAuthorizations",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const not_allowed_plans = ['4Change Energy', 'Constellation', 'Frontier Utilities', 'Gexa Energy', 'Just Energy', 'Tara Energy', 'Amigo Energy', 'Flagship Power'];
    const { selected_plan } = SelectedPlan();
    const { plan_brand } = Utilities();
    const authorizations = ref([]);
    watch(authorizations, () => {
      const agreed = authorizations.value.length === 3
      emit('update:modelValue', agreed);
    })
    return {
      not_allowed_plans,
      authorizations,
      selected_plan,

      plan_brand
    }
  }
}
</script>

<style scoped>

</style>
